// Cover art, and the scopes a cover can be pinned to.

export interface Artwork {
  id: number;
  url: string;
  source: "upload" | "caa" | "deezer" | "itunes" | "generated" | "logo";
}

/** A cover pinned to a recurring series or a DJ billing. Tracks pin to their identity. */
export interface ArtworkPin {
  show_id: number | null;
  /** The billing as it is matched: folded for case and whitespace, not as typed. */
  dj_key: string | null;
  /** The series as the schedule last named it. Null on a DJ pin, or an unknown series id. */
  show_title: string | null;
  artwork_id: number;
  url: string;
  pinned_at: string;
}

/** A series or billing whose airings have no cover: the Covers page's work list. */
export interface CoverlessScope {
  show_id: number | null;
  /** Folded, as stored on a pin. Sent straight back as `djs`; the server folds again. */
  dj_key: string | null;
  /** The billing as captured, for the label. Null on a series scope. */
  djs: string | null;
  show_title: string | null;
  /** How many of this scope's airings have no cover. */
  coverless: number;
  last_seen: string;
}

/**
 * The scope a cover pin applies to, as one comparable key: `show:19` or `dj:totalrage`.
 *
 * Mirrors `scope_clause` in worker/artwork.py -- the series id wins and the folded billing is
 * the fallback -- so a stored pin, a schedule row and a pending write all reduce to the same
 * string. The fold is Python's `strip().lower()` written in JS; an already-folded `dj_key`
 * survives it unchanged, which is what lets a stored pin be keyed by the same call.
 */
export function scopeKey(showId: number | null, djs: string | null): string {
  return showId !== null ? `show:${showId}` : `dj:${(djs ?? "").trim().toLowerCase()}`;
}
